<template>
   <div>
      <Carousel></Carousel>
   </div>
</template>

<script>
   import Carousel from './Carousel.vue';
   export default {
      components: {
         Carousel
      }
   }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/home/Home.vue